var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145.6 33.5",
    style: {
      enableBackground: "new 0 0 145.6 33.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0083D7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24 -29)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 29)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,18.2c1.5-0.3,2.5-1.7,2.4-3.2c0.1-1-0.4-2-1.2-2.6c-1-0.7-2.1-1-3.3-0.9h-6.2v13.8H23 c1.5,0,2.6-0.3,3.4-1c0.8-0.7,1.2-1.7,1.2-2.8c0-0.8-0.2-1.5-0.7-2.1C26.3,18.8,25.6,18.4,24.8,18.2z M19.9,14.2H22 c1.2,0,1.8,0.5,1.8,1.5c0,1-0.6,1.5-1.7,1.5h-2.2L19.9,14.2z M22.3,22.6h-2.4v-3.1h2.4c0.5,0,1,0.1,1.4,0.4 c0.3,0.3,0.5,0.7,0.5,1.2C24.1,22.1,23.5,22.6,22.3,22.6L22.3,22.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3,
    y: 14.4,
    className: "st0",
    width: 3.3,
    height: 10.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.9,15c-1.8-0.9-4-0.9-5.8,0c-0.8,0.4-1.5,1.1-2,1.9c-0.5,0.9-0.8,1.9-0.7,3c0,1,0.2,2.1,0.7,3 c0.5,0.8,1.2,1.5,2,1.9c0.9,0.4,1.9,0.7,2.9,0.7c1,0,2-0.2,2.9-0.7c0.8-0.4,1.5-1.1,2-1.9c0.5-0.9,0.8-1.9,0.7-3 c0-1-0.2-2.1-0.7-3C44.4,16.1,43.7,15.4,42.9,15z M41.6,21.9c-0.9,0.9-2.3,0.9-3.1,0.1c0,0,0,0-0.1-0.1c-0.5-0.6-0.7-1.3-0.6-2 c-0.1-0.7,0.2-1.4,0.6-2c0.9-0.9,2.3-0.9,3.1-0.1c0,0,0,0,0.1,0.1c0.5,0.6,0.7,1.3,0.6,2C42.3,20.6,42.1,21.3,41.6,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.4,11.6l-5,13.7h3.5l0.9-2.5h5.2l0.9,2.5h3.5l-5-13.7H51.4z M51.6,20.3l1.7-5.1l1.7,5.1H51.6L51.6,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.1,20.2c0,0.7-0.2,1.3-0.6,1.8c-0.9,0.8-2.3,0.9-3.2,0c-0.4-0.5-0.6-1.1-0.6-1.7v-5.9h-3.3v6.3 c-0.1,1.2,0.3,2.5,1.1,3.4c0.8,0.8,1.8,1.3,3,1.2c0.8,0,1.5-0.2,2.1-0.6c0.6-0.4,1.1-0.9,1.4-1.5v2h3.3V14.5H69L69.1,20.2 L69.1,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.3,16.4c-0.3-0.6-0.7-1.2-1.3-1.5c-0.6-0.4-1.4-0.6-2.1-0.6c-0.8,0-1.7,0.2-2.4,0.7 c-0.7,0.5-1.3,1.1-1.7,1.9c-0.4,0.9-0.6,2-0.6,3c0,1,0.2,2,0.6,3c0.4,0.8,0.9,1.5,1.7,1.9c0.7,0.4,1.6,0.7,2.4,0.7 c0.8,0,1.5-0.2,2.1-0.6c0.6-0.4,1-0.9,1.3-1.5v2h3.3V10.9h-3.3V16.4z M81.7,21.8c-0.4,0.5-1.1,0.7-1.7,0.7c-0.6,0-1.3-0.2-1.7-0.7 c-0.5-0.5-0.7-1.2-0.6-2c0-0.7,0.2-1.4,0.6-2c0.9-0.9,2.5-0.9,3.4,0c0.5,0.5,0.7,1.2,0.7,1.9C82.4,20.6,82.1,21.3,81.7,21.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.9,
    y: 14.4,
    className: "st0",
    width: 3.3,
    height: 10.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.8,22.2c-0.2-0.3-0.3-0.6-0.3-0.9v-4.1h2.2v-2.8h-2.2v-2.7h-3.3v2.7h-1.5v2.8h1.5v4c0,1.5,0.3,2.5,1.1,3.1 c0.8,0.7,1.9,1,3,0.9h1.5v-2.9h-1.1C98.4,22.5,98.1,22.4,97.8,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.1,14.6l-4,10.7h1.5l0.9-2.5h4.8l0.9,2.5h1.5l-4-10.7L106.1,14.6z M104.9,21.7l2-5.5l2,5.5H104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.5,14.4h-3.5v10.9h1.4v-4.4h2.1c1,0.1,2-0.2,2.8-0.9c0.7-0.6,1-1.5,1-2.4c0.1-0.9-0.3-1.8-0.9-2.4 C118.7,14.7,117.8,14.4,116.5,14.4z M118.3,19.2c-0.5,0.4-1.2,0.6-1.8,0.5h-1.9v-4.2h1.9c0.7-0.1,1.3,0.1,1.8,0.5 c0.4,0.4,0.6,1,0.6,1.5C118.9,18.3,118.7,18.8,118.3,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.1,15.3c-0.8-0.6-1.8-1-2.8-0.9h-3.5v10.9h1.4v-4.4h2.1c1,0.1,2-0.2,2.8-0.9c0.7-0.6,1-1.5,1-2.4 C129.1,16.8,128.8,15.9,128.1,15.3z M127.1,19.2c-0.5,0.4-1.2,0.6-1.8,0.5h-1.9v-4.2h1.9c0.7-0.1,1.3,0.1,1.8,0.5 c0.4,0.4,0.6,1,0.6,1.5C127.7,18.3,127.5,18.8,127.1,19.2L127.1,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29,11.3c0.1,1.1,1,1.9,2.1,1.8c1-0.1,1.7-0.8,1.8-1.8c0-1-2-3.3-2-3.3S29,10.3,29,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.6,11.3c0.1,1.1,1,1.9,2.1,1.8c1-0.1,1.7-0.8,1.8-1.8c0-1-2-3.3-2-3.3S87.6,10.3,87.6,11.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logoMini.b5b4421f.svg";
export { ForwardRef as ReactComponent };